import React from 'react';

import { env } from '@admitkard/uiutils/env';
import { FETCH_MENTOR_URL } from 'resources/common/api';

import { ConnectWithMentors } from 'components/ConnectWithMentors';
import { MentorsDetailsInterface, MentorsDetailsListInterface } from 'components/ConnectWithMentors/AkMentorsListing';
import { http } from '@admitkard/uiutils/http';

interface ConnectWithMentorProps {
  success: boolean;
  message: string;
  statusCode: number;
  data: {
    total: number;
    result: MentorsDetailsInterface[];
  };
}

export default class UniversityPage extends React.Component<MentorsDetailsListInterface> {
  static async getInitialProps() {
    // Fetching Mentors List from the server
    const mentorsListUrl = `${env.IAM_API}${FETCH_MENTOR_URL}`;
    const MentorsListingJSON = await http.post<ConnectWithMentorProps>(mentorsListUrl);

    if (MentorsListingJSON.data.success && MentorsListingJSON.data.data) {
      return ({
        mentorsListing: MentorsListingJSON.data.data.result,
      });
    } else {
      // TODO @MAYANK: Handle Situation
      return {};
    }
  }

  render() {
    return <ConnectWithMentors mentorsListing={this.props.mentorsListing} />;
  }
}
